import { Controller } from "@hotwired/stimulus"
import { setPendingFile } from "../util/pending_content_upload"

// Connects to the data-controller="content-upload-trigger"
export default class extends Controller {
  static values = { newUrl: String }

  open(event) {
    const file = event.target.files && event.target.files[0]
    if (!file)
      return

    setPendingFile(file)
    this.openModalFrame()
    event.target.value = ""
  }

  openModalFrame() {
    const frame = document.getElementById("modal_content")
    if (frame)
      frame.src = this.newUrlValue
  }
}
